





















































































































































import { apiUrl } from "@/domain";
import Vue from "vue";
import ApiService from "@/services/ApiService";
import VueUploadComponent from "vue-upload-component";
import ImageCompressor from "compressorjs";

export default Vue.extend({
  data() {
    return {
      logo: [],
      rolesAvailable: [
        {
          label: "Administrator",
          value: "administrator",
        },
        {
          label: "Headmaster",
          value: "headmaster",
        },
        {
          label: "Bursar",
          value: "bursar",
        },
      ],
      form: {
        password: "",
        first_name: this.$store.state.user.first_name,
        last_name: this.$store.state.user.last_name,
        email: this.$store.state.user.email,
        name: this.$store.state.user.domain.name,
        contacts: [
          { id: null, email: "", first_name: "", last_name: "", role: "" },
        ],
      },
      logo_type: "",
      uploadUrl:
        apiUrl +
        "/api/uploadFile?notice&school_id=" +
        this.$route.params.school_id,
    };
  },
  components: {
    "file-upload": VueUploadComponent,
  },
  methods: {
    updateAdminInfo() {
      ApiService.generalApi
        .updateAdminInfo(this.form)
        .then(() => {
          this.$message("Updated");
          this.refreshAdmin();
        })
        .catch((err) => {
          alert(err);
        });
    },
    refreshAdmin() {
      ApiService.generalApi.refreshAdmin().then((resp) => {
        this.$store.dispatch("refreshAdminInfo", resp.data);
        this.form.logo_url = resp.data.user.domain.logo_url;
      });
    },
    inputFile: function (newFile, oldFile) {
      if (newFile && oldFile && !newFile.active && oldFile.active) {
        // newFile.error = "compressor";
        // Get response data
        const response = newFile.xhr.response;
        if (response) {
          this.form.logo = response;
          this.refreshAdmin();
        } else {
          return;
        }
      }
      // Automatic upload
      if (
        Boolean(newFile) !== Boolean(oldFile) ||
        oldFile.error !== newFile.error
      ) {
        if (newFile.error == "") {
          this.imagesLoading = true;
          if (!this.$refs.upload.active) {
            new ImageCompressor(newFile.file, {
              quality: 0.9,
              maxHeight: 1200,
              success: (result) => {
                // Successfully deleted the error to write the new file
                this.$refs.upload.update(newFile, {
                  file: result,
                  error: "",
                  size: result.size,
                  type: result.type,
                });
                setTimeout(() => {
                  this.$refs.upload.active = true;
                }, 200);
              },
            });
          }
        }
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (!/\.(gif|jpg|jpeg|png|webp)$/i.test(newFile.name)) {
          this.alert("Your choice is not a picture");
          return prevent();
        }
      }
      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        newFile.url = "";
        const URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          newFile.url = URL.createObjectURL(newFile.file);
        }
      }
    },
  },
  computed: {
    accType: function () {
      return this.$store.state.user.admin_type.name;
    },
    token: function () {
      return "Bearer " + this.$store.state.token;
    },
    user: function () {
      return this.$store.state.user;
    },
  },
  mounted() {
    const user = JSON.parse(JSON.stringify(this.user));
    this.form = {
      logo_url: user.domain.logo_url,
      first_name: user.first_name,
      last_name: user.last_name,
      email: user.email,
      name: user.domain.name,
      contacts: [
        { id: null, email: "", first_name: "", last_name: "", role: "" },
        { id: null, email: "", first_name: "", last_name: "", role: "" },
      ],
    };
    this.logo_type =
      this.accType === "SCHOOL_ADMIN" ? "school_logo" : "council_logo";
  },
});
